// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"style_languageSwitcher__p9R3j","dropdown":"style_dropdown__24Wcu","dropdownContent":"style_dropdownContent__gaCUW"};